import type { CSSProperties } from 'react';

import { cx } from './classNames';

/** Pendant zu `SfChip` mit einem `ChipItem`. */
export interface ChipProps {
  text: string;
  /** Zustandsvariante des Chips, z. B. `e-warning`. */
  cssClass?: string;
  id?: string;
  className?: string;
  style?: CSSProperties;
  title?: string;
}

export function Chip(props: ChipProps) {
  return (
    <div
      id={props.id}
      style={props.style}
      title={props.title}
      className={cx('e-chip-list', props.className)}
    >
      <div className={cx('e-chip', props.cssClass)}>
        {/* Die Marke kürzt zu lange Beschriftungen (REQ-17 §3); der vollständige
            Text bleibt über `title` lesbar. */}
        <span className="e-chip-text" title={props.text}>
          {props.text}
        </span>
      </div>
    </div>
  );
}

export default Chip;
